import querystring from 'querystring'
import router from '@/router'

export const getCoreApiLatestData = data => {
    let lastData = null

    if (
        data
        && data.data
        && data.data.at(-1)
        && data.data.at(-1).data
    ) {
        lastData = data.data.at(-1).data.at(-1)
    }

    return lastData
}

export const getCoreApiLatestObject = data => {
    let lastestObject = null
    if (
        data
        && data.data
        && data.data.at(-1)
    ) {
        lastestObject = data.data.at(-1)
    }

    return lastestObject
}

export const getCoreApiByObjectId = (data, id) => {
    let object = null
    if (
        data
        && data.data
    ) {
        data.data.forEach(obj => {
            if (
                obj.returnedAs
              && obj.returnedAs.indexOf(id) > -1
            ) {
                object = obj
            }
        })
    }

    return object
}

export const getHashList = () => {
    let currentHashList = {}
    if (router.currentRoute.hash) {
        currentHashList = querystring.parse(router.currentRoute.hash.slice(1))
    }
    return currentHashList
}
